<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Registration Content</h4>
                    </div>
                    <div class="card-body">
                        <form class="forms-sample" enctype="multipart/form-data" method="post" @submit.stop.prevent="updateHomeContent"
                            autocomplete="off">
                            <div class="row mt-5">
                                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                                    <div class="row flex-grow">
                                        <div class="col-12">
                                            <div class="">
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginRegistrationText1" class="d-inline-block">Registration Text
                                                                    1
                                                                </label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginRegistrationText1status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginRegistrationText1status', homeContentData.PreLoginRegistrationText1status)">
                                                                    {{ homeContentData.PreLoginRegistrationText1status == 1
                                                                        ? "hide" : 'show' }} </button>
                                                                <div style="width: 100%; overflow: auto">
                                                                    <ckeditor id="PreLoginRegistrationText1"
                                                                        v-model="homeContentData.PreLoginRegistrationText1" :config="editorConfig">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginRegistrationText1.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginRegistrationText2" class="d-inline-block">Registration Text
                                                                    2</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginRegistrationText2status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginRegistrationText2status', homeContentData.PreLoginRegistrationText2status)">
                                                                    {{ homeContentData.PreLoginRegistrationText2status == 1
                                                                        ? "hide" : 'show' }} </button>
                                                                <div style="width: 100%; overflow: auto;">
                                                                    <ckeditor id="PreLoginRegistrationText2"
                                                                        v-model="homeContentData.PreLoginRegistrationText2" :config="editorConfig1">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginRegistrationText2.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginRegistrationText3" class="d-inline-block">Registration Text
                                                                    3</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginRegistrationText3status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginRegistrationText3status', homeContentData.PreLoginRegistrationText3status)">
                                                                    {{ homeContentData.PreLoginRegistrationText3status == 1
                                                                        ? "hide" : 'show' }} </button>
                                                                <div style="width: 100%; overflow: auto;">
                                                                    <ckeditor id="PreLoginRegistrationText3"
                                                                        v-model="homeContentData.PreLoginRegistrationText3" :config="editorConfig2">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginRegistrationText3.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginRegistrationText4" class="d-inline-block">Registration Text
                                                                    4</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginRegistrationText4status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginRegistrationText4status', homeContentData.PreLoginRegistrationText4status)">
                                                                    {{ homeContentData.PreLoginRegistrationText4status == 1
                                                                        ? "hide" : 'show' }} </button>
                                                                <div style="width: 100%; overflow: auto;">
                                                                    <ckeditor id="PreLoginRegistrationText4"
                                                                        v-model="homeContentData.PreLoginRegistrationText4" :config="editorConfig3">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginRegistrationText4.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginRegistrationText5" class="d-inline-block">Registration Text
                                                                    5</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginRegistrationText5status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginRegistrationText5status', homeContentData.PreLoginRegistrationText5status)">
                                                                    {{ homeContentData.PreLoginRegistrationText5status == 1
                                                                        ? "hide" : 'show' }} </button>

                                                                <div style="width: 100%; overflow: auto">
                                                                    <ckeditor id="PreLoginRegistrationText5"
                                                                        v-model="homeContentData.PreLoginRegistrationText5" :config="editorConfig4">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginRegistrationText5.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginRegistrationText6" class="d-inline-block">Registration Text
                                                                    6</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginRegistrationText6status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginRegistrationText6status', homeContentData.PreLoginRegistrationText6status)">
                                                                    {{ homeContentData.PreLoginRegistrationText6status == 1
                                                                        ? "hide" : 'show' }} </button>

                                                                <div style="width: 100%; overflow: auto">
                                                                    <ckeditor id="PreLoginRegistrationText6"
                                                                        v-model="homeContentData.PreLoginRegistrationText6" :config="editorConfig5">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginRegistrationText6.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginRegistrationText7" class="d-inline-block">Registration Text
                                                                    7</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginRegistrationText7status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginRegistrationText7status', homeContentData.PreLoginRegistrationText7status)">
                                                                    {{ homeContentData.PreLoginRegistrationText7status == 1
                                                                        ? "hide" : 'show' }} </button>

                                                                <div style="width: 100%;overflow: auto">
                                                                    <ckeditor id="PreLoginRegistrationText7"
                                                                        v-model="homeContentData.PreLoginRegistrationText7" :config="editorConfig6">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginRegistrationText7.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginRegistrationText9" class="d-inline-block">Registration Text
                                                                    9</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginRegistrationText9status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginRegistrationText9status', homeContentData.PreLoginRegistrationText9status)">
                                                                    {{ homeContentData.PreLoginRegistrationText9status == 1
                                                                        ? "hide" : 'show' }} </button>

                                                                <div style="width: 100%; overflow: auto">
                                                                    <ckeditor id="PreLoginRegistrationText9"
                                                                        v-model="homeContentData.PreLoginRegistrationText9" :config="editorConfig7">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginRegistrationText9.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6"></div>
                                                        <div class="col-md-6 mt-3">
                                                            <b-button type="submit" variant="success"
                                                                class="btn float-right btn-success">
                                                                Submit
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);

export default {
    name: "seminar_content",
    mixins: [validationMixin],
    data() {
        return {
            homeContentData: {
                PreLoginRegistrationText1: "",
                PreLoginRegistrationText2: "",
                PreLoginRegistrationText3: "",
                PreLoginRegistrationText4: "",
                PreLoginRegistrationText5: "",
                PreLoginRegistrationText6: "",
                PreLoginRegistrationText7: '',
                PreLoginRegistrationText9: '',
            },
            editorConfig: { 
                versionCheck: false 
            },
            editorConfig1: { 
                versionCheck: false 
            },
            editorConfig2: { 
                versionCheck: false 
            },
            editorConfig3: { 
                versionCheck: false 
            },
            editorConfig4: { 
                versionCheck: false 
            },
            editorConfig5: { 
                versionCheck: false 
            },
            editorConfig6: { 
                versionCheck: false 
            },
            editorConfig7: { 
                versionCheck: false 
            },
        }
    },
    validations: {
        homeContentData: {
            PreLoginRegistrationText1: {
                required
            },
            PreLoginRegistrationText2: {
                required
            },
            PreLoginRegistrationText3: {
                required
            },
            PreLoginRegistrationText4: {
                required
            },
            PreLoginRegistrationText5: {
                required
            },
            PreLoginRegistrationText6: {
                required
            },
            PreLoginRegistrationText7: {
                required
            },
            PreLoginRegistrationText9: {
                required
            },

        }
    },
    methods: {
        activeDeactiveContent(field, s) {
            let status = s == true ? 0 : 1;
            this.homeContentData[field] = status;
            API.activeDeactiveContent({ field, status }, this.activeDeactiveContentCB, this.errorCB);
        },
        activeDeactiveContentCB(res) {
            this.$showNotification(res.data, 'success')
        },
        updateHomeContent() {
            this.$v.homeContentData.$touch();
            if (this.$v.homeContentData.$anyError ) {
                return;
            }
            API.updateHomeContent(this.homeContentData, this.updateHomeContentCB, this.errorCB)
        },
        updateHomeContentCB(res) {
            this.homeContentData = res.data;
            this.$showNotification(res, 'success')
        },
        getWebContent() {
            API.getWebContent(this.getWebContentCB, this.errorCB)
        },
        getWebContentCB(res) {
            this.homeContentData = res.data;
            this.$showNotification(res, 'success')
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.getWebContent();
    },
    components: {}
}
</script>
